type ImageDimensions = {
  width: number;
  height: number;
  aspectRatio: number;
};
/**
 * Gets the dimensions and aspect ratio of an image file
 * @param file - The image file to analyze
 * @returns Promise resolving to image dimensions and aspect ratio
 * @throws Error if the file cannot be loaded as an image
 */
export const getImageDimensions = (file: File): Promise<ImageDimensions> =>
  new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(url);
      const width = img.naturalWidth;
      const height = img.naturalHeight;
      const aspectRatio = width / height;

      resolve({width, height, aspectRatio});
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Failed to load image'));
    };

    img.src = url;
  });
